import { useQuery } from '@tanstack/react-query';

import { getUniversityCourseSelect, globalConst, ISecondRoot } from '..';

export const useUniversityCourseSelect = (universityId?: string) => {
  const { data, ...args } = useQuery<{ univerCourse: ISecondRoot[] }>({
    queryKey: [globalConst.queryKeys.GET_UNIVERSITY_COURSE_SELECT, universityId],
    queryFn: getUniversityCourseSelect({ universityId })
  });

  return { ...data, ...args };
};
